import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import '../../assets/css/columsplitup.css';
const Video = ({Data}) => {
    if(Data !== null && Data !== undefined && Data[0].rtelist !== null && Data[0].rtelist !== undefined && Data[1].videolist !== null && Data[1].videolist !== undefined) {
        return (
            <div className="columncontrol">
                <div className="row">
                    <div className="columnscontrol">
                        <div className="firstdiv col-sm-4 col-md-4">
                            <div className="rte">
                                <div className="row">
                                    <div className="dsl-part setup-services-section">
                                        <div className="setup-services-part columns tiny-12">
                                            {ReactHtmlParser(Data[0].rtelist[0].richText)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="seconddiv col-sm-8 col-md-8">
                            <div className="video">
                                <div className="help_vids">
                                    <div className="video">
                                        <iframe tabIndex="-1" aria-hidden="true" className="" src={Data[1].videolist[0].videoid}></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return null;
    }
}

export default Video


// WEBPACK FOOTER //
// ./src/components/modules/Video.js